import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormLabel } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { FormContext } from "../../util/context";
import { Button } from "@material-ui/core";

const Name = () => {
  const [form, setForm] = useContext(FormContext);
  return (
    <>
      <Container maxWidth="sm">
        <Box paddingLeft={4}>
          <Typography align="center" component={"span"} variant="h5">
            Please provide an email address to book your appointment.
          </Typography>
        </Box>
        <Box mt={5}>
          <Container maxWidth="sm">
            <Grid container={true} spacing={2}>
              <Grid item={true} xs={12}>
                <FormLabel id="outlined-multiline-flexible">
                  <Typography variant="subtitle1" component={"span"}>
                    Email
                  </Typography>
                </FormLabel>
                <TextField
                  id="outlined-multiline-flexible"
                  variant="outlined"
                  type="text"
                  placeholder="john@parados.app"
                  value={form.email}
                  fullWidth={true}
                  onChange={(event) =>
                    setForm({ ...form, email: event.target.value })
                  }
                />
              </Grid>
              <Grid item={true} xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={() => setForm({ ...form, count: form.count + 1 })}
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Container>
    </>
  );
};

export default Name;
